import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { H2, H3, H5 } from '@blueprintjs/core';

import { simpleArrStrToStr } from '../../../utils';


class Recap extends React.PureComponent {

  makeGlobalRecap = (recap, t) => (
    <div className="margin-bottom-1-5-rem">
      <H5><u>{t('global')}</u></H5>

      <p>{t('caracteristics')}</p>
      <ul>
        <li>{t('langColon')} {recap.global.lang}</li>
        {recap.global.alignedLang &&
          <li>{t('alignedLangColon')} {simpleArrStrToStr(recap.global.alignedLang)}</li>
        }
      </ul>

      <p>{t('stats')}</p>
      <ul>
        <li>{t('nbSentsToParseColon')} {recap.global.nbSents2Parse}</li>
        <li>{t('nbParsedSentsColon')} {recap.global.nbParsedSents}</li>
      </ul>
      <p>{t('elapsedTime')} {recap.global.elapsed.toFixed(2)} s.</p>
    </div>
  )

  render() {
    const { recap, t } = this.props;

    const subCorporaRecap = recap.subCorpora.map(subCorp => (
      <div key={subCorp.name} className="margin-bottom-1-5-rem">
        <H5><u>{subCorp.name}</u></H5>
        <ul>
          <li>{t('collectionColon')} {subCorp.collection[0]}</li>
          {subCorp.constraints && subCorp.constraints.categories &&
            <li>{t('categoriesColon')} {simpleArrStrToStr(subCorp.constraints.categories)}</li>
          }
          {subCorp.constraints && subCorp.constraints.year &&
            <li>{t('periodColon')} {subCorp.constraints.year[0]} - {subCorp.constraints.year.slice(-1)[0]}</li>
          }
          {subCorp.source_language &&
            <li>{t('sourceLangsColon')} {simpleArrStrToStr(subCorp.source_language)}</li>
          }
          {subCorp.nb_toks &&
            <li>{t('tokenNumColon')} {subCorp.nb_toks}</li>
          }
        </ul>
      </div>
    ));

    return (
      <div className="margin-bottom-1-5-rem">
        <H2 className="margin-bottom-1-5-rem">{t('recapSearchAndResults')}</H2>
        <H3>{t('querySentColon')}</H3>
        <p className="margin-bottom-1-5-rem">{recap.query}</p>

        <H3>{t('searchArea')}</H3>
        {recap.subCorpora.length > 1 && this.makeGlobalRecap(recap, t)}
        {subCorporaRecap}
      </div>
    );
  }
}

Recap.propTypes = {
  recap: PropTypes.object,
};

export default withTranslation()(Recap);
